import { z } from 'zod'
import { UserSchema, UserUpdatePatch } from '~/shared/user/user.supabase.schema'

// Contract between the /api/user/me route and its client caller.
// The authenticated caller's JWT identifies the user; no input body.
export const UserMeOutput = UserSchema
export type UserMeOutput = z.output<typeof UserMeOutput>

// Contract between /api/user/update and its client caller.
export const UserUpdateInput = UserUpdatePatch
export type UserUpdateInput = z.infer<typeof UserUpdateInput>

export const UserUpdateOutput = UserSchema
export type UserUpdateOutput = z.output<typeof UserUpdateOutput>
